<template>
  <b-modal
    id="modal"
    ref="modal"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    v-model="showModal"
  >
    <div class="col-md-12 col-sm-12">
      <label>Valor para adiantar</label>
      <currency-input
        class="form-control"
        v-model="form.vlr"
        placeholder=""
        :auto-decimal-mode="true"
        :locale="getCurrency.locale"
        style="text-align: right"
        :currency="{ prefix: 'R$ ' }"
        :distraction-free="getCurrency"
        :disabled="this.modal_acao == 'u' && this.update_erro"
      />
      <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('vlr')"
                v-if="form.errors.has('vlr')"
              ></b-form-feedback>
    </div>
    <div class="col-md-12 col-sm-12">
      <label>Descrição</label>
      <b-form-input
        type="text"
        placeholder="Descrição"
        v-model="form.descr"
        name="descr"
      >
      </b-form-input>
      <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('descr')"
                v-if="form.errors.has('descr')"
              ></b-form-feedback>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-right">
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      update_erro: true,
      tpArquivoSelected: [],
      optionsTpArquivo: [],
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      data: [],
      form: new Form({
        vlr: 0,
        descr: "",
        carga_id: "",
        descar_id: "",
      }),
      helpForm: new Form({
        recordCollection: [],
        docfisCollection: [],
        status: "",
      }),
    };
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.descar_id);
      }
    },
    onCreate(id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Adiantamento de Valor";
      this.modal_botao = "Enviar";
      this.modal_acao = "i";
      this.form.reset();
      this.form.vlr = 0;
      this.form.descr = "";
      this.form.carga_id = "";
      this.form.descar_id = "";
      this.data = [];
      this.form.carga_id = id;
      this.$refs.modal.show();
    },
    onEdit(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Adiantamento de Valor";
      this.modal_botao = "Enviar";
      this.modal_acao = "u";
      this.form.reset();
      if(data.statusErp.valor == 3 || data.statusDespesa.valor != 2) {
        this.update_erro = false;
      }
      this.form.vlr = Number(data.despesa.vlr);
      this.form.descr = data.despesa.descr;
      this.form.descar_id = data.descar_id;
      this.data = [];
      this.$refs.modal.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.vlr = Number(this.form.vlr);
      this.form
        .post("/api/gerenciamentotransporte/adiantamento")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/gerenciamentotransporte/adiantamento/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
  },
  computed: {
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  },
};
</script>
